// extracted by css-extract-rspack-plugin
export default {"root":"_FwhUFxvSU1ml4of","actions":"GkKpipSrA4MBbGWI"};